import { FormLoadingIndicator } from 'components/shared/FormLoadingIndicator/FormLoadingIndicator';
import { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import type { LoadRfqRouteProps } from './LoadRfqRoute.connect';
import { connectLoadRfqRoute } from './LoadRfqRoute.connect';

const Component: FC<LoadRfqRouteProps> = ({ onLoadRfq }) => {
  const { rfqId } = useParams();

  useEffect(() => onLoadRfq(rfqId!), [rfqId, onLoadRfq]);

  return (
    <div className="variations-page page-container">
      <div className="max-width-container">
        <div className="load-rfq-form container-fluid q-wrapper quote-request">
          <div>
            <FormLoadingIndicator />
            Loading quote
          </div>
        </div>
      </div>
    </div>
  );
};
Component.displayName = 'LoadQuoteRoute';

export const LoadRfqRoute = connectLoadRfqRoute(Component);
